import { LinkProps, ModuleProps } from "@/utils/types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Load plugins and set default timezone
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("America/Chicago");

export interface EventProps extends ModuleProps {
  title: string;
  date: string;
  endDate?: string;
  address: string;
  isBottom?: boolean;
  link?: LinkProps;
}

export const Event = ({
  className,
  componentId,
  title,
  date,
  endDate,
  lightMode = false,
  address,
  link,
  isBottom = false,
}: EventProps) => {
  const formatTime = (dateStr: string) => {
    const d = dayjs.utc(dateStr).tz("America/Chicago"); // convert from UTC to Central
    return d.minute() === 0 ? d.format("h A") : d.format("h:mm A");
  };

  const breakAddressAtComma = (address: string) => {
    const firstCommaIndex = address?.indexOf(",");
    return firstCommaIndex === -1
      ? address
      : address?.slice(0, firstCommaIndex);
  };

  return (
    <div
      id={componentId}
      className={`event w-full max-w-[650px] border-t-2 ${
        lightMode ? "border-primaryShade" : "border-secondary"
      }${isBottom ? " border-b-2" : ""} py-4 mx-auto${className ? ` ${className}` : ""}`}
    >
      <div className="flex items-start gap-4 md:items-center w-full justify-between flex-col md:flex-row">
        <div>
          <p
            className={`font-display text-[35px] max-w-[400px] leading-[1.1] ${
              lightMode ? "text-black" : "text-tertiary"
            }`}
          >
            {title}
          </p>
          <p
            className={`font-extrabold uppercase flex items-start ${
              lightMode ? "text-black" : "text-white"
            }`}
          >
            <span>
              {dayjs.utc(date).tz("America/Chicago").format("ddd, MMM. DD")}
              <span className="text-[12px]">
                <br />
                {formatTime(date)}
                {endDate && (
                  <>
                    {" - "}
                    {formatTime(endDate)}
                  </>
                )}
              </span>
            </span>
            {breakAddressAtComma(address) && <>&nbsp;&nbsp;|&nbsp;&nbsp;</>}
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${address}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {breakAddressAtComma(address)}
            </a>
          </p>
        </div>
        {link && (
          <a
            className={`button small ${lightMode ? "primary" : "tertiary"}`}
            href={link.href}
          >
            {link.copy}
          </a>
        )}
      </div>
    </div>
  );
};
